import { calculateInputs, calculateOutputs } from './common.js';
export const estimateFee = ({ inputIndexesToSign, currency, psbt, simulationResult, }) => {
    const inputAmount = calculateInputs({ psbt, inputIndexesToSign });
    const outputAmount = calculateOutputs({ psbt });
    const diff = inputAmount.sub(outputAmount);
    const fee = currency.baseUnit(diff.gtn(0) ? diff.toString() : '0');
    simulationResult.balanceChanges.willPayFee.push({ balance: fee });
};
